export enum Zorgtype {
    initieleBehandeling = '11',
    intercollegiaalConsult = '13',
    overigZorgproduct = '41',
    vervolgBehandeling = '21',
}
